import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FileImportModal from '../Shared/FileImportModal';
import { importCustomersFile } from '../../redux/slices/customersImportSlice';

const ImportCustomersModal = ({ open, onClose, t, onImportComplete }) => {
  const dispatch = useDispatch();
  const { importErrors } = useSelector((state) => state.customersImport);

  const handleImportCustomers = async (file) => {
    try {
      const response = await dispatch(importCustomersFile(file, t));
      return response.payload || response;
    } catch (error) {
      console.error("Customer import error:", error);
      return { success: false, errors: [] };
    }
  };

  const formattedErrors = (Array.isArray(importErrors) ? importErrors : []).map(error => {
    const row = error?.row?.toString() || t('unknown_row');
    const columns = error.column

    const translatedColumns = columns
      .filter(Boolean)
      .map(col => t(`${col.toLowerCase()}`, { defaultValue: col }))
      .join(', ');

    return columns.length > 1
      ? t('row_errors', { row, columns: translatedColumns })
      : t('row_error', { row, columns: translatedColumns });
  });

  return (
    <FileImportModal
      open={open}
      onClose={onClose}
      t={t}
      onImportComplete={onImportComplete}
      onImport={handleImportCustomers}
      title="Import Customers"
      description="Upload an Excel file (.xlsx or .xls) containing customer data. The file should follow the required format."
      templateUrl="/assets/templates/Kundenimport Vorlage.xlsx"
      templateName="Kundenimport Vorlage"
      acceptedFileTypes={[
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ".xlsx",
        ".xls"
      ]}
      errorMessage="No customers were imported because"
      importErrors={formattedErrors}
    />
  );
};

export default ImportCustomersModal;
